import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calculator, Loader2, Search } from "lucide-react";
import { ReservationDetailDialog } from "@/components/ReservationDetailDialog";
import { api } from "@/lib/api";

export const ReservationSearch = ({ testId = "resa-search" }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [charge, setCharge] = useState(false);
  const [choisie, setChoisie] = useState(null);
  const minuterie = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    clearTimeout(minuterie.current);
    if (q.trim().length < 3) { setRes(null); return undefined; }
    minuterie.current = setTimeout(() => {
      setCharge(true);
      api.get("/reservations/recherche", { params: { q: q.trim() } }).then((r) => setRes(r.data)).catch(() => setRes([])).finally(() => setCharge(false));
    }, 300);
    return () => clearTimeout(minuterie.current);
  }, [q]);
  const fermer = useCallback(() => setChoisie(null), []);
  const boite = useRef(null);
  useEffect(() => {
    if (!res) return undefined;
    const dehors = (e) => { if (boite.current && !boite.current.contains(e.target)) setRes(null); };
    const echap = (e) => { if (e.key === "Escape") setRes(null); };
    document.addEventListener("mousedown", dehors);
    document.addEventListener("keydown", echap);
    return () => { document.removeEventListener("mousedown", dehors); document.removeEventListener("keydown", echap); };
  }, [res]);
  return (
    <div className="relative" ref={boite}>
      <Search className="absolute left-2.5 top-2.5 h-3.5 w-3.5 text-slate-500" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="N° de réservation…" data-testid={`${testId}-input`}
        className="h-9 w-full rounded-md border border-white/10 bg-white/5 pl-8 pr-8 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-emerald-500" />
      {charge && <Loader2 className="absolute right-2.5 top-2.5 h-3.5 w-3.5 animate-spin text-slate-400" />}
      {res && (
        <div className="absolute z-50 mt-1 w-72 max-w-[90vw] rounded-md border border-slate-200 bg-white shadow-lg" data-testid={`${testId}-results`}>
          {!res.length ? <p className="p-3 text-xs text-slate-500">Aucune réservation trouvée.</p> : res.map((r) => (
            <div key={r.id} className="flex items-stretch border-b border-slate-100 last:border-0">
            <button type="button" onClick={() => { setChoisie(r); setQ(""); }} className="block min-w-0 flex-1 px-3 py-2 text-left hover:bg-emerald-50" data-testid={`${testId}-result-${r.code}`}>
              <span className="font-mono text-sm font-semibold text-slate-900">{r.code}</span>
              <span className="ml-2 text-xs text-slate-500">{r.plateforme}</span>
              <span className="block text-xs text-slate-600 truncate">{r.nom_client || "—"} · {r.date_debut} → {r.date_fin} · {r.logement}</span>
              <span className="block text-[11px] text-emerald-700">{r.depots.length ? `Dépôt du ${r.depots[0].date}` : "Pas de dépôt rapproché"}{r.factures.length ? " · facture de commission" : ""}</span>
            </button>
            <button type="button" title="Vérifier dans le calculateur" aria-label="Vérifier dans le calculateur" onClick={() => { setRes(null); setQ(""); navigate(`/calcul-reservation?reservation=${r.id}`); }}
              className="grid w-10 shrink-0 place-items-center border-l border-slate-100 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-900" data-testid={`${testId}-calculer-${r.code}`}><Calculator className="h-4 w-4" /></button>
            </div>
          ))}
          {res.length === 8 && <p className="px-3 py-1.5 text-[11px] text-slate-500" data-testid={`${testId}-plus`}>8 premiers résultats — précisez le numéro.</p>}
        </div>
      )}
      <ReservationDetailDialog rid={choisie?.id} initial={choisie} onClose={fermer} />
    </div>
  );
};
